const SIZES = {
  DROPDOWN_MIN_WIDTH: 300,
}

export default SIZES
